import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultLastActiveSlice = getCachedTableDataSlice<
    Record<string, Record<string, string>>,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userGroupsSearchResultLastActive');

export const userSearchResultLastActiveActions = userSearchResultLastActiveSlice.actions;

const userSearchResultLastActiveCacheSelector: CachedTableCacheSelector<Record<string, Record<string, string>>>
    = state => state.accountPage.tabs.usersAndGroups.userSearchResult.lastActive.cache;
export const userSearchResultLastActiveDataSelector: CachedTableDataSelector<Record<string, Record<string, string>>>
    = state => state.accountPage.tabs.usersAndGroups.userSearchResult.lastActive;
export const userSearchResultLastActiveResultSelector = getCachedTableResultSelector(
    userSearchResultLastActiveCacheSelector,
    userSearchResultStateSelector,
);
